import { render, staticRenderFns } from "./GamePlayerAFK.vue?vue&type=template&id=21fa0510&scoped=true&"
import script from "./GamePlayerAFK.vue?vue&type=script&lang=js&"
export * from "./GamePlayerAFK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa0510",
  null
  
)

export default component.exports